const Component = () => import('./UpcomingDeliveries');

export { Component };
